import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = guest
  const [loading, setLoading] = useState(true);
  const authSeq = useRef(0);

  useEffect(() => {
    if (!user || !user.id) return;
    let code;
    try { code = localStorage.getItem("metros_ref"); } catch (e) { code = null; }
    if (!code) return;
    api.post("/account/referral/apply", { code })
      .then(({ data }) => { if (data?.applied) toast.success("🎁 Referral applied! Your friend earns points on your first order."); })
      .catch(() => {})
      .finally(() => { try { localStorage.removeItem("metros_ref"); } catch (e) { /* ignore */ } });
  }, [user]);

  const refresh = useCallback(async () => {
    const seq = ++authSeq.current;
    try {
      const { data } = await api.get("/auth/me");
      if (seq === authSeq.current) setUser(data);
    } catch {
      if (seq === authSeq.current) setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, skip the /me check — AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    authSeq.current++;
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    authSeq.current++;
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}
